import { Iframe } from "@jmc/core/src/components/Iframe/iframe";
import { useLocale } from "@jmc/core/src/hooks/useLocale/index";
import React, { useEffect, useState } from "react";

import style from "./style.module.scss";

interface Props {
    source: string;
    hide_scrollbars?: boolean;
    container_scale?: boolean;
    fullWidth?: boolean;
    iframe_size?: {
        unit: "px" | "%" | "VH";
        value: number;
    };
}

export const IframeComponent = (props: Props): JSX.Element => {
    const { source, hide_scrollbars, container_scale, fullWidth, iframe_size } = props;

    const [accepted, setAccepted] = useState("loading");

    const locale = useLocale();

    useEffect(() => {
        const scriptStatus = (): void => {
            setAccepted(window.OptanonActiveGroups as string);
        };

        window.addEventListener("OptanonActiveGroupsChanged", scriptStatus);

        return () => {
            window.removeEventListener("OptanonActiveGroupsChanged", scriptStatus);
        };
    }, [accepted]);

    const options = {
        scrolling: !hide_scrollbars,
        sizeHeight: !container_scale,
    };

    // Parameters won't work with iFrames coming from /static while developing in localhost.
    // To avoid problems you can set GATSBY_ENVIRONMENT=local in your .env.development file.
    let enhancedSource = source;
    if (typeof window !== "undefined" && process.env.GATSBY_ENVIRONMENT !== "local") {
        const urlHelper = new URL(source, window?.origin || "https://localhost/");
        urlHelper?.searchParams?.set("optanonactivegroups", window?.OptanonActiveGroups);
        urlHelper?.searchParams?.set("locale", locale);
        enhancedSource = source?.match(/^(http|https):\/\//i)
            ? urlHelper.toString()
            : urlHelper?.pathname + urlHelper?.search;
    }

    const element = (
        <Iframe
            src={enhancedSource}
            fullSize={container_scale}
            options={options}
            height={iframe_size?.value}
            unit={iframe_size?.unit}
        ></Iframe>
    );

    return fullWidth ? <div className={style.fullWidth}>{element}</div> : element;
};

export default IframeComponent;
